import { Link } from 'react-router-dom';
import { Heart, ArrowUpRight, Star, Gamepad2 } from 'lucide-react';
import type { Game } from '../../shared/types';
import { usePlatform } from '../store';
import { gameTitle, gameCover } from '../game-presentation';
import { ResponsiveImage } from './ResponsiveImage';
export function GameArt({
  game,
  className = '',
  sizes,
  priority = false,
}: {
  game: Game;
  className?: string;
  sizes?: string;
  priority?: boolean;
}) {
  return (
    <div className={`game-art ${className} ${game.id === 'demo-2048' ? 'numbers-art' : ''}`}>
      {gameCover(game) ? (
        <ResponsiveImage
          src={gameCover(game)}
          sizes={sizes}
          alt=""
          loading={priority ? 'eager' : 'lazy'}
          fetchPriority={priority ? 'high' : undefined}
          decoding="async"
        />
      ) : (
        <div className="art-type">
          {game.id === 'demo-2048' ? (
            <>
              <span>THINK. MOVE. MERGE.</span>
              <strong>
                2048<span>↗</span>
              </strong>
              <small>一个数字，无限可能</small>
            </>
          ) : (
            <Gamepad2 size={64} />
          )}
        </div>
      )}
    </div>
  );
}
export function GameCard({ game, compact = false }: { game: Game; compact?: boolean }) {
  const { data, toggleFavorite } = usePlatform();
  return (
    <article className={`game-card${compact ? ' coastal-game-card' : ''}`}>
      <Link to={'/game/' + game.slug} className="card-cover" aria-label={`${gameTitle(game)}详情`}>
        <GameArt game={game} />
        <span className={`availability ${game.free ? 'free' : ''}`}>
          {game.free ? '免费畅玩' : '抢先体验'}
        </span>
        <span className="cover-arrow">
          <ArrowUpRight size={23} />
        </span>
      </Link>
      <div className="card-body">
        <div className="card-meta">
          <span>{game.categories.join(' / ')}</span>
          <span className="rating">
            <Star size={13} fill={game.rating ? 'currentColor' : 'none'} />
            {game.rating ? game.rating.toFixed(1) : '待评分'}
          </span>
        </div>
        <div className="card-title">
          <Link to={'/game/' + game.slug}>{gameTitle(game)}</Link>
          <button
            className={`icon-button favorite ${data?.favorites.includes(game.id) ? 'selected' : ''}`}
            aria-label={`${data?.favorites.includes(game.id) ? '取消收藏' : '收藏'}${gameTitle(game)}`}
            aria-pressed={data?.favorites.includes(game.id) || false}
            onClick={() => void toggleFavorite(game)}
          >
            <Heart size={19} fill={data?.favorites.includes(game.id) ? 'currentColor' : 'none'} />
          </button>
        </div>
        <p>{game.description}</p>
        <div className="card-bottom">
          <span>{game.mode} · 浏览器即玩</span>
          <Link to={'/game/' + game.slug}>
            探索游戏 <ArrowUpRight size={14} />
          </Link>
        </div>
      </div>
    </article>
  );
}
